import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ApplicationsColumnsService } from '../../../services';
import { Application } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-post-details',
  templateUrl: './application-details.component.html',
  styleUrls: ['./application-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ApplicationDetailsComponent implements OnInit {

  public application: Application = {};
  public columns: Column[] = [];

  constructor(
    private router: Router,
    private dynamicDialogConfig: DynamicDialogConfig,
    private applicationsColumnsService: ApplicationsColumnsService,
  ) { }

  ngOnInit(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.post !== 'undefined') {
      this.application = this.dynamicDialogConfig.data.post;
    }
    this.columns = this.applicationsColumnsService.getColumns();

    for (let i = 0; i <= this.columns.length; i++) {
      if (this.columns[i].field === "actions") {
        this.columns.splice(i, 1);
      }
    }
  }


}
@Component({
  selector: 'app-post-details',
  templateUrl: './application-details.component.html',
  styleUrls: ['./application-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogApplicationDetailsComponent extends ApplicationDetailsComponent {
}

